import moment from "moment";
import React from "react";
import { FiArrowDown } from "react-icons/fi";
import Invoice from "../../Assets/invoices.png";
import stripe from "../../Assets/stripe.png";

const InvoiceEmail = ({ cusField, invoiceList }) => {

  const getTotal = () => {
    const totalList = invoiceList.map((val) => {
      return (val.qty ? val.qty : 1) * val.price
    })

    let sum = 0
    totalList.forEach(x => sum += x);
    return sum
  }

  return (
    <>
      <div className="mt-[20px] shadow-shadow100">
        <div className="p-[16px_24px_12px_24px]">
          <h1 className="text-[14px] font-[700] text-[#414552]">
            New invoice from abc
          </h1>
          <p className="text-[#414552] text-[11px] font-[500]">
            <span className="font-[700]">to:</span> {cusField.account_email}
          </p>
        </div>
        <div className="bg-[#f0f2f8] select-none">
          <div className="max-w-[380px] mx-auto px-[10px]">
            <h1 className="text-[16px] font-[500] pt-[46px]">abc</h1>
            <div className="bg-[#fff] p-[32px] pr-[30px] mt-[26px] rounded-[12px] shadow-shadow200">
              <div>
                <div className="flex justify-between items-center">
                  <div className="w-full">
                    <p className="text-[#7A7A7A] text-[14px] font-[500]">
                      Invoice from abc
                    </p>
                    <h1 className="text-[#1A1A1A] text-[35px] font-[600] leading-[40px]">
                      ${getTotal()}.00
                    </h1>
                    <p className="text-[#7A7A7A] text-[14px] font-[500] pb-[10px] border-b-[1px] border-b-[#aaa3] mb-[10px]">
                      Due {moment(Date()).format("MMMM DD, yyyy")}
                    </p>
                  </div>
                  <img
                    src={Invoice}
                    alt="Invoice"
                    className="w-[94px] mr-[-12px]"
                  />
                </div>
                <div>
                  <p className="text-[#7A7A7A] text-[14px] font-[500] flex items-center gap-1">
                    <FiArrowDown className="text-[18px]" />
                    Download invoice
                  </p>
                  <table className="text-[14px] mt-[32px]">
                    <tbody>
                      <tr>
                        <td className="text-[#7A7A7A]">To</td>
                        <td className="w-[20px]"></td>
                        <td className="text-[#1A1A1A]">{cusField.name}</td>
                      </tr>
                      <tr>
                        <td className="text-[#7A7A7A]">From</td>
                        <td className="w-[20px]"></td>
                        <td className="text-[#1A1A1A]">abc</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button className="bg-[#0074d4] text-white w-full rounded-[6px] h-[44px] mt-[24px] text-[14px]">
                  Pay this invoice
                </button>
              </div>
            </div>
            <div className="bg-[#fff] p-[32px] pr-[30px] pb-[24px] mt-[26px] rounded-[12px] shadow-shadow200">
              <p className="text-[#1A1A1A] text-[12px] font-[600]">
                Invoice #FAD3488C-DRAFT
              </p>
              {invoiceList.map((val) => (
                <div className="mt-[26px] border-b-[1px] border-b-[#aaa3] pb-[16px]">
                  <div className="flex justify-between items-center">
                    <p className="text-[#1A1A1A] text-[12px] font-[500]">
                      {val.item}
                    </p>
                    <p className="text-[#1A1A1A] text-[12px] font-[500]">
                      ${val.price * (val.qty ? val.qty : 1)}.00
                    </p>
                  </div>
                  <p className="text-[#999999] text-[12px]">Qty {val.qty}</p>
                </div>
              ))}
              <div className="mt-[16px] border-b-[1px] border-b-[#aaa3] pb-[16px]">
                <div className="flex justify-between items-center">
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">
                    Total due
                  </p>
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">
                    ${getTotal()}.00
                  </p>
                </div>
              </div>
              <div className="mt-[16px] border-b-[1px] border-b-[#aaa3] pb-[16px]">
                <div className="flex justify-between items-center">
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">
                    Amount paid
                  </p>
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">$0.00</p>
                </div>
                <div className="flex justify-between items-center mt-[8px]">
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">
                    Amount remaining
                  </p>
                  <p className="text-[#1A1A1A] text-[12px] font-[500]">
                    ${getTotal()}.00
                  </p>
                </div>
              </div>
              <div className="mt-[20px] flex text-[12px] gap-[2px]">
                <p className="text-[#999999]">Questions? Contact us at</p>
                <a href="/" className="text-[#625afa] font-bold">
                  {localStorage.getItem("email")}
                </a>
              </div>
            </div>
            <div className="text-[#aaa] text-[12px] flex justify-center items-center mt-[30px] pb-[50px]">
              <p>Powered by</p>
              <img
                src={stripe}
                alt="stripe"
                className="w-[46px] opacity-[.5]"
              />
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <p>Learn more about Stripe Invoicing</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceEmail;
